import React from 'react'

const LoadingFailed = (props: { text: string, additionalInfo?: string }) => {
  const { text, additionalInfo } = props

  return (
    <div
      className='d-flex flex-column align-items-center position-absolute mt-3'
      style={{
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <h1 className='text-danger'>&times;</h1>
      <h4>{text}</h4>
      <p className="text-muted small">{additionalInfo}</p>
      <p>Zurück zur <a href='/'>Startseite</a></p>
    </div>
  )
}

export default LoadingFailed
